'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiDelete = function (_React$Component) {
    _inherits(AiDelete, _React$Component);

    function AiDelete() {
        _classCallCheck(this, AiDelete);

        return _possibleConstructorReturn(this, (AiDelete.__proto__ || Object.getPrototypeOf(AiDelete)).apply(this, arguments));
    }

    _createClass(AiDelete, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M24.863,26.462c0.905,0,1.739,0,2.623,0c0,7.917,0,9.446,0,16.712c-0.854,0-1.719,0-2.623,0 C24.863,35.694,24.863,33.985,24.863,26.462z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M30.766,26.459c0.908,0,1.743,0,2.632,0c0,7.487,0,9.206,0,16.725c-0.872,0-1.736,0-2.632,0 C30.766,35.687,30.766,33.985,30.766,26.459z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M39.362,43.209c-0.901,0-1.735,0-2.617,0c0-7.497,0-9.218,0-16.729c0.864,0,1.715,0,2.617,0 C39.362,33.95,39.362,35.669,39.362,43.209z' }),
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M41.418,26.479c0.002,6.507,0.002,10.43,0,17.346c0,1.264-0.241,1.499-1.519,1.499c-5.197,0.001-10.394,0.001-15.591,0 c-1.266,0-1.514-0.247-1.514-1.502c0-6.915,0-10.837,0-17.343h-2.706c0.005,6.369,0.038,10.133-0.027,16.901 c-0.021,2.187,0.644,3.782,2.743,4.62c6.176,0,12.352,0,18.527,0c1.261-0.485,2.275-1.237,2.623-2.616 c0.131-0.52,0.175-1.074,0.175-1.612c0.01-6.901,0.008-10.762,0.008-17.292L41.418,26.479L41.418,26.479z' }),
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M45.418,24.104c0.003-1.722,0.026-2.84-1.043-3.373c-0.459-0.229-1.029-0.332-1.556-0.36 c-1.063-0.057-2.131-0.024-3.197-0.031c-0.041,0-0.082-0.031-0.213-0.083c0-0.205,0.009-0.447-0.002-0.687 c-0.078-1.778-1.323-3.556-3.123-3.563c-2.745-0.011-5.49-0.007-8.234-0.002c-1.988,0.004-3.173,1.74-3.225,3.716 c-0.005,0.178-0.02,0.356-0.037,0.634c-1.144,0-2.27,0.005-3.395-0.002c-0.749-0.005-1.654,0.035-2.301,0.717 c-0.389,0.41-0.511,0.92-0.511,1.499c0,0.512,0,1.023,0,1.535H45.418z M28.332,18.19c2.513-0.001,5.026-0.001,7.539,0 c1.174,0,1.424,0.862,1.287,2.132c-3.378,0-6.718,0-10.053,0C27.046,19.372,27.128,18.19,28.332,18.19z' })
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-delete', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-delete', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiDelete;
}(_react2.default.Component);

exports.default = AiDelete;